<template>
    <div class="openapi_list" v-if="selectedOpenApiTab === '01'">
        <ul class="list">
            <OpenapiBox v-for="(datasrc, index) in displayList" v-if="index >= (page - 1) * listSize && index < page * listSize"
                        :datasrc="datasrc" :key="index"/>
        </ul>

        <div class="pagination">
            <div class="first" @click.prevent="moveFirst()"></div>
            <div class="prv" @click.prevent="movePrev()"></div>
            <ul class="pag">
                <li v-for="i in end" v-if="i > start" :class="{on: i === page}"
                    @click.prevent="movePage(i)">{{ i }}</li>
            </ul>
            <div class="next" @click.prevent="moveNext()"></div>
            <div class="last" @click.prevent="moveLast()"></div>
        </div>

    </div>
</template>

<script>
import {mapGetters} from "vuex";
import OpenapiBox from "@/views/openapi/OpenapiBox";

export default {
    components: {
        OpenapiBox,
    },
    data() {
        return {
            selectedDatasrcCate: '',
            listSize: 5,
            pageSize: 5,
            page: 1,
            searchVal: "",
        }
    },
    computed: {
        ...mapGetters({
            datasrcList: 'getDatasrcList',
            selectedOpenApiTab: 'getSelectedOpenApiTab',
        }),
        displayList() {
            let list = this.datasrcList;
            if(this.selectedDatasrcCate !== ''){
                list = this.datasrcList.filter(d => {
                    let dataCateCd = d.cates[0].dataCateCd
                    if(typeof dataCateCd !== this.$_TYPE.UNDEF && dataCateCd === this.selectedDatasrcCate){
                        return true;
                    }
                });
            }
            if(!!this.searchVal) {
                list = list.filter((d) => {
                    let originNm = !!d.origin.originNm ? d.origin.originNm : "";
                    let dataSrcNm = !!d.dataSrcNm ? d.dataSrcNm : "";
                    let dataKdTit = !!d.dataKd.dataKdTit ? d.dataKd.dataKdTit : "";
                    if(originNm.includes(this.searchVal) || dataSrcNm.includes(this.searchVal) || dataKdTit.includes(this.searchVal)) {
                        // console.log('d', d.origin.originNm, d.dataSrcNm, d.dataKd.dataKdTit);
                        return true;
                    }
                });
            }
            return list;
        },
        start(){
            return Math.floor((this.page - 1) / this.pageSize) * this.pageSize;
        },
        end(){
            return Math.ceil(this.totalCount / this.listSize) < this.start + this.pageSize ? Math.ceil(this.totalCount / this.listSize) : this.start + this.pageSize;
        },
        totalCount() {
            return this.displayList.length;
        },
    },
    created() {
        this.$eventBus.$on('OpenapiTab::select-datasrc-cate', (code) => {
            this.page = 1;
            this.selectedDatasrcCate = code;
        });

        this.$eventBus.$on('OpenapiTab::search-openapi', (searchVal) => {
            this.page = 1;
            this.searchVal = searchVal;
        });
    },
    methods: {
        movePage(page) {
            this.page = page;
        },
        movePrev(){
            if(this.start > 0){
                this.page = this.start;
            }
        },
        moveNext(){
            if(this.listSize * this.end < this.totalCount){
                this.page = this.end + 1;
            }
        },
        moveFirst(){
            this.movePage(1);
        },
        moveLast(){
            this.movePage(Math.ceil(this.totalCount / this.listSize));
        },
    },
}
</script>
